// Login.tsx
import React, { useState, FormEvent, ChangeEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'src/Contexts/AuthContext';
import { authService } from 'src/api/services';
import { useBrand } from 'src/branding';
import warning from 'src/assets/warning.png';

import './Login.css';

const Login: React.FC = () => {
  const [email, setEmail] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [error, setError] = useState<boolean>(false);
  const [errorMsg, setErrorMsg] = useState<string>('');

  const { login } = useAuth();
  const brand = useBrand();
  const navigate = useNavigate();

  const handleSubmit = async (e: FormEvent<HTMLFormElement>): Promise<void> => {
    e.preventDefault();
    setError(false);

    try {
      const userData = await authService.login(email, password);

      if (userData.token) {
        await login(
          userData.token,
          userData.email,
          userData.is_admin,
          userData.userId,
          userData.name,
          userData.preferred_language,
          userData.refreshToken
        );
        navigate('/', { replace: true });
      }
    } catch (err) {
      setError(true);
      const errorMessage =
        (err as any).apiError?.message || (err as Error).message || 'Login failed';
      setErrorMsg(errorMessage);
    }
  };

  const handleEmailChange = (e: ChangeEvent<HTMLInputElement>): void => {
    setEmail(e.target.value);
  };

  const handlePasswordChange = (e: ChangeEvent<HTMLInputElement>): void => {
    setPassword(e.target.value);
  };

  return (
    <div className="login-page">
      <h2 className="title">Welcome to the Monitoring Portal</h2>

      <form onSubmit={(e) => void handleSubmit(e)} aria-label="Login form">
        <div className="email">
          <input
            value={email}
            onChange={handleEmailChange}
            type="email"
            id="email"
            required
            aria-required="true"
            aria-label="Email address"
            placeholder=" "
          />
          <label htmlFor="email">E-Mail</label>
        </div>

        <div className="password">
          <input
            value={password}
            onChange={handlePasswordChange}
            type="password"
            id="password"
            required
            aria-required="true"
            aria-label="Password"
            placeholder=" "
          />
          <label htmlFor="password">Password</label>
        </div>

        <span className="login-info">
          Lost Login Data? Please contact <b>{brand.contactEmail}</b>
        </span>

        {error && <img src={warning} alt="Error warning icon" className="status" />}
        {error && (
          <span className="error" role="alert" aria-live="polite">
            Process Failed: {errorMsg}
          </span>
        )}

        <button type="submit" aria-label="Submit login credentials">
          Login
        </button>
      </form>
    </div>
  );
};

export default Login;
